import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listSingularDays,
  listSingularGroupNames,
} from '@ebalance/proto/bffuser/v1/singular_day_service-SingularDayService_connectquery'

/**
 * 特異日カレンダーマスタ関連の React Query キー定義。
 * mutation 成功時の invalidate に使用する (= fiscal_year を問わず全 List
 * variant を再取得させるため input を指定しない prefix key)。
 */
export const singularDayQueryKeys = {
  list: createConnectQueryKey({
    schema: listSingularDays,
    cardinality: 'finite',
  }),
  /** 特異グループ表示名一覧 (design Note singular-group-names.md)。 */
  groupNameList: createConnectQueryKey({
    schema: listSingularGroupNames,
    cardinality: 'finite',
  }),
} as const
